module.exports = __webpack_public_path__ + "img/11_Kombipaket-3.63cb9c71.jpg";